import { isMobile } from 'react-device-detect';

import { updateEmployeeProfileRoute } from 'shared/routes';
import { theme } from 'shared/styles/theme';
import { definitions } from 'shared/types/APISchema';
import { Box } from 'shared/ui/Box';
import { Checkbox } from 'shared/ui/Checkbox/Checkbox';
import { Icon } from 'shared/ui/Icon';
import { Link } from 'shared/ui/Link';
import { Popover } from 'shared/ui/Popover/Popover';
import { Spinner } from 'shared/ui/Spinner';
import { ExternalLink, LinkButton } from 'shared/ui/Styled';
import { Flex } from 'shared/ui/StyledComponents';
import { Typography } from 'shared/ui/Typography';

import { getDateAndTimeFromDeadline } from '../lib/getDateAndTimeFromDeadline';
import { factory } from '../model/model';

type Props = {
  id: string;
  link: string;
  isCompleted: boolean;
  isLoading?: boolean;
  item: definitions['MinEmployeeTodoTask'];
};

export const TodoListItemForContest = ({ id, link, item, isCompleted, isLoading }: Props) => {
  const model = factory.useModel();

  return (
    <Flex
      backgroundColor={!isCompleted ? '' : theme.colors.gray300}
      padding={!isCompleted ? 0 : 15}
      borderRadius={!isCompleted ? 0 : theme.borderRadius}
      position='relative'
    >
      <Flex gap={10} alignItems={isMobile ? '' : 'center'}>
        {isLoading ? (
          <Spinner />
        ) : (
          !isCompleted &&
          !item?.isAutomatic && (
            <Checkbox
              onChange={() => model.completeTask({ task_id: item?.id.toString() })}
              checked={item?.completed}
              alignItems={isMobile ? '' : 'center'}
            />
          )
        )}
        {item?.isAutomatic && !isCompleted && (
          <Popover text='Эта задача закроется автоматически' bottom='20px' left='20px'>
            <Checkbox onChange={() => null} checked={item?.completed} disabled />
          </Popover>
        )}
        {isCompleted && (
          <Popover text='Эта задача уже закрыта' bottom='30px' left='30px'>
            <Flex
              borderRadius={8}
              backgroundColor={theme.colors.black}
              width={24}
              height={24}
              alignItems='center'
              justifyContent='center'
              minWidth={24}
            >
              <Icon name='accept' width={16} height={16} color='white' />
            </Flex>
          </Popover>
        )}
        <Box>
          <Flex gap={5} alignItems={isMobile ? '' : 'center'} flexWrap='wrap'>
            <Typography fontSize={theme.fontSizes['17']}>Заполни</Typography>
            <Link to={updateEmployeeProfileRoute} params={{ id: id }}>
              <LinkButton>
                <Typography fontSize={theme.fontSizes['17']}>свой профиль</Typography>
              </LinkButton>
            </Link>
            <Typography fontSize={theme.fontSizes['17']}>до</Typography>
            <Typography fontSize={theme.fontSizes['17']}>{getDateAndTimeFromDeadline(item.deadline)},</Typography>
            <Typography fontSize={theme.fontSizes['17']}>чтобы поучаствовать в</Typography>
            <LinkButton>
              <ExternalLink href={link} target='_blank' rel='noreferrer'>
                <Typography fontSize={theme.fontSizes['17']}>конкурсе</Typography>
              </ExternalLink>
            </LinkButton>
          </Flex>
        </Box>
      </Flex>
    </Flex>
  );
};
